var zipper = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/zipper_4_colorCorrected_c.jpg'
var zipperDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/zipper_detail_4A_colorCorrected.jpg';
var zipperDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/zipper_detail_4C_colorCorrected.jpg'
var checkmate = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/checkmate_05_colorCorrected.jpg'
var checkmateDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/checkmate_detail_06_colorCorrected.jpg'
var lock = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/lock_03_colorCorrected.jpg'
var lockDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/lock_detail_04_colorCorrected.jpg'
var hook = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/hook_8_colorCorrected_b.jpg'
var intersection = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/intersection_2_colorCorrected.jpg'
var intersectionDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/intersection_detail_2B_colorCorrected.jpg'
var crossing = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/crossing_6_colorCorrected_b.jpg'
var crossingDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/crossing_detail_6A_colorCorrected.jpg'
var crossingDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/crossing_detail_6B_colorCorrected.jpg'
var tangle = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/tangle.jpg'
var tangleDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/tangleDetail1.jpg'


export const allImagesDesktopOrderIntersections = [
    [/*COLUMN 1*/
        [
            {
                name: zipper,
                artistName: "Lorraine Shemesh",
                title: "Zipper",
                year: "2008",
                dimensions: "78 1/4 x 48 1/4 in., o/c",
                link: "int9",
                privateCollection: ""
            },
            {
                name: zipperDetail1,
                artistName: "Lorraine Shemesh",
                title: "Zipper - detail",
                year: "2008",
                dimensions: "78 1/4 x 48 1/4 in., o/c",
                link: "int10",
                privateCollection: ""
            },
            {
                name: zipperDetail2,
                artistName: "Lorraine Shemesh",
                title: "Zipper - detail",
                year: "2008",
                dimensions: "78 1/4 x 48 1/4 in., o/c",
                link: "int11",
                privateCollection: ""
            }
        ],
        [
            {
                name: checkmate,
                artistName: "Lorraine Shemesh",
                title: "Checkmate",
                year: "2008",
                dimensions: "35 1/4 x 79 3/4 in., o/c",
                link: "int12",
                privateCollection: ""
            },
            {
                name: checkmateDetail1,
                artistName: "Lorraine Shemesh",
                title: "Checkmate - detail",
                year: "2008",
                dimensions: "35 1/4 x 79 3/4 in., o/c",
                link: "int13",
                privateCollection: ""
            }
        ],
        [
            {
                name: lock,
                artistName: "Lorraine Shemesh",
                title: "Lock",
                year: "2009",
                dimensions: "46 3/4 x 78 1/4 in., o/c",
                link: "int14",
                privateCollection: ""
            },
            {
                name: lockDetail1,
                artistName: "Lorraine Shemesh",
                title: "Lock - detail",
                year: "2009",
                dimensions: "46 3/4 x 78 1/4 in., o/c",
                link: "int15",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: hook,
                artistName: "Lorraine Shemesh",
                title: "Hook",
                year: "2007",
                dimensions: "80 1/4 x 42 1/2 in., o/c",
                link: "int8",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: intersection,
                artistName: "Lorraine Shemesh",
                title: "Intersection",
                year: "2007",
                dimensions: "72 1⁄4 x 52 1/4 in., o/c",
                link: "int3",
                privateCollection: "Permanent Collection of The National Academy of Design"
            },
            {
                name: intersectionDetail1,
                artistName: "Lorraine Shemesh",
                title: "Intersection - detail",
                year: "2007",
                dimensions: "72 1⁄4 x 52 1/4 in., o/c",
                link: "int4",
                privateCollection: "Permanent Collection of The National Academy of Design"
            }
        ],
    ],
    [/*COLUMN 3*/
        [
            {
                name: crossing,
                artistName: "Lorraine Shemesh",
                title: "Crossing",
                year: "2008",
                dimensions: "73 x 54 1/4 in., o/c",
                link: "int5",
                privateCollection: ""
            },
            {
                name: crossingDetail1,
                artistName: "Lorraine Shemesh",
                title: "Crossing - detail",
                year: "2008",
                dimensions: "73 x 54 1/4 in., o/c",
                link: "int6",
                privateCollection: ""
            },
            {
                name: crossingDetail2,
                artistName: "Lorraine Shemesh",
                title: "Crossing - detail",
                year: "2008",
                dimensions: "73 x 54 1/4 in., o/c",
                link: "int7",
                privateCollection: ""
            }
        ],
        [
            {
                name: tangle,
                artistName: "Lorraine Shemesh",
                title: "Tangle",
                year: "2010",
                dimensions: "52 x 38 1/2 in., o/c",
                link: "int16",
                privateCollection: ""
            },
            {
                name: tangleDetail1,
                artistName: "Lorraine Shemesh",
                title: "Tangle - detail",
                year: "2010",
                dimensions: "52 x 38 1/2 in., o/c",
                link: "int16",
                privateCollection: ""
            }
        ]
    ]          
]


export const allImagesMobileOrderIntersections = [
    [{
        name: intersection,
        artistName: "Lorraine Shemesh",
        title: "Intersection",
        year: "2007",
        dimensions: "72 1⁄4 x 52 1/4 in., o/c",
        link: "int3",
        privateCollection: "Permanent Collection of The National Academy of Design"
    },
    {
        name: intersectionDetail1,
        artistName: "Lorraine Shemesh",
        title: "Intersection - detail",
        year: "2007",
        dimensions: "72 1⁄4 x 52 1/4 in., o/c",
        link: "int4",
        privateCollection: "Permanent Collection of The National Academy of Design"
    },
    {
        name: crossing,
        artistName: "Lorraine Shemesh",
        title: "Crossing",
        year: "2008",
        dimensions: "73 x 54 1/4 in., o/c",
        link: "int5",
        privateCollection: ""
    },
    {
        name: crossingDetail1,
        artistName: "Lorraine Shemesh",
        title: "Crossing - detail",
        year: "2008",
        dimensions: "73 x 54 1/4 in., o/c",
        link: "int6",
        privateCollection: ""
    },
    {
        name: crossingDetail2,
        artistName: "Lorraine Shemesh",
        title: "Crossing - detail",
        year: "2008",
        dimensions: "73 x 54 1/4 in., o/c",
        link: "int7",
        privateCollection: ""
    },
    {
        name: hook,
        artistName: "Lorraine Shemesh",
        title: "Hook",
        year: "2007",
        dimensions: "80 1/4 x 42 1/2 in., o/c",
        link: "int8",
        privateCollection: "Private Collection"
    },
    {
        name: zipper,
        artistName: "Lorraine Shemesh",
        title: "Zipper",
        year: "2008",
        dimensions: "78 1/4 x 48 1/4 in., o/c",
        link: "int9",
        privateCollection: ""
    },
    {
        name: zipperDetail1,
        artistName: "Lorraine Shemesh",
        title: "Zipper - detail",
        year: "2008",
        dimensions: "78 1/4 x 48 1/4 in., o/c",
        link: "int10",
        privateCollection: ""
    },
    {
        name: zipperDetail2,
        artistName: "Lorraine Shemesh",
        title: "Zipper - detail",
        year: "2008",
        dimensions: "78 1/4 x 48 1/4 in., o/c",
        link: "int11",
        privateCollection: ""
    },
    {
        name: checkmate,
        artistName: "Lorraine Shemesh",
        title: "Checkmate",
        year: "2008",
        dimensions: "35 1/4 x 79 3/4 in., o/c",
        link: "int12",
        privateCollection: ""
    },
    {
        name: checkmateDetail1,
        artistName: "Lorraine Shemesh",
        title: "Checkmate - detail",
        year: "2008",
        dimensions: "35 1/4 x 79 3/4 in., o/c",
        link: "int13",
        privateCollection: ""
    },
    {
        name: lock,
        artistName: "Lorraine Shemesh",
        title: "Lock",
        year: "2009",
        dimensions: "46 3/4 x 78 1/4 in., o/c",
        link: "int14",
        privateCollection: ""
    },
    {
        name: lockDetail1,
        artistName: "Lorraine Shemesh",
        title: "Lock - detail",
        year: "2009",
        dimensions: "46 3/4 x 78 1/4 in., o/c",
        link: "int15",
        privateCollection: ""
    },
    {
        name: tangle,
        artistName: "Lorraine Shemesh",
        title: "Tangle",
        year: "2010",
        dimensions: "52 x 38 1/2 in., o/c",
        link: "int16",
        privateCollection: ""
    },
    {
        name: tangleDetail1,
        artistName: "Lorraine Shemesh",
        title: "Tangle - detail",
        year: "2010",
        dimensions: "52 x 38 1/2 in., o/c",
        link: "int16",
        privateCollection: ""
    }
    ]      
]